/* Order form for the country sites (US, Canada, Australia, New Zealand; Katie 2 Nov 2026).
   Same steps and line item properties as the UK form (fallback-order.js, which stays as it is for UK orders),
   with the country's address fields, no print step, and "country" plus address/city/region/postcode in _book. */
(function () {
  var root = document.getElementById('fb-order');
  var cfgEl = document.getElementById('fb-config');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var site = cfg.site;

  var want = new URLSearchParams(location.search).get('edition');
  var state = {
    step: 0,
    counts: { adults: 1, kids: 0, pets: 0 },
    flags: [],
    people: [{ name: '', called: '', mobile: '', place: '', townOnly: false }],
    edition: cfg.editions.some(function (e) { return e.key === want; }) ? want : 'family'
  };
  var mins = { adults: 1, kids: 0, pets: 0 };
  var $ = function (id) { return document.getElementById(id); };
  var money = function (p) { return '$' + (p % 100 ? (p / 100).toFixed(2) : String(p / 100)); };
  var edition = function () { return cfg.editions.filter(function (e) { return e.key === state.edition; })[0] || cfg.editions[0]; };
  var val = function (id) { return ($(id).value || '').trim(); };
  var el = function (tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  };
  var filledPeople = function () { return state.people.filter(function (p) { return p.name.trim() || p.place.trim(); }); };
  var noPeople = function () { return edition().max === 0; };
  var skipped = function (i) { return noPeople() && (i === 2 || i === 3); };
  var kidCard = function () { return state.counts.kids > 0 && edition().key !== 'area' ? val('f-kid') : ''; };

  // pre = 'f-' for the buyer's home, 'f-s-' for the second address
  function postcode(pre) {
    var p = val((pre || 'f-') + 'postcode').toUpperCase().replace(/\s+/g, ' ');
    if (site.postCase === 'ca') {
      var m = p.replace(/\s/g, '').match(/^([A-Z]\d[A-Z])(\d[A-Z]\d)$/);
      if (m) p = m[1] + ' ' + m[2];
    }
    return p;
  }
  // "2035 S Naper Blvd, Naperville, IL 60565" (US/CA) or "30 Parke St, Katoomba NSW 2780" (AU) or "34 Moorefield Road, Johnsonville, Wellington 6037" (NZ)
  function homeLine(pre) {
    pre = pre || 'f-';
    var a = val(pre + 'address'), c = val(pre + 'city'), r = val(pre + 'region'), p = postcode(pre);
    if (site.country === 'AU') return a + ', ' + c + ' ' + r + ' ' + p;
    return a + ', ' + c + ', ' + r + ' ' + p;
  }

  root.querySelectorAll('.counter').forEach(function (c) {
    var key = c.getAttribute('data-count');
    c.addEventListener('click', function (ev) {
      var b = ev.target.closest('button');
      if (!b) return;
      state.counts[key] = Math.max(mins[key], Math.min(20, state.counts[key] + Number(b.getAttribute('data-d'))));
      render();
    });
  });

  $('fb-flags').addEventListener('click', function (ev) {
    var b = ev.target.closest('.chip');
    if (!b) return;
    var f = b.getAttribute('data-flag');
    var i = state.flags.indexOf(f);
    if (i === -1) state.flags.push(f); else state.flags.splice(i, 1);
    b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
  });

  function drawPeople() {
    var box = $('fb-people');
    box.textContent = '';
    state.people.forEach(function (p, i) {
      var wrap = el('div', { class: 'person' });
      var head = el('div', { class: 'person-head' });
      head.appendChild(el('b', null, p.called || p.name || 'Person ' + (i + 1)));
      var rm = el('button', { type: 'button', class: 'textbtn' }, 'Remove');
      rm.addEventListener('click', function () { state.people.splice(i, 1); drawPeople(); render(); });
      head.appendChild(rm);
      wrap.appendChild(head);
      var row = el('div', { class: 'row' });
      [['name', 'Full name', 'name'], ['called', 'What should the book refer to them as?', 'off'], ['mobile', site.mobileLabel, 'off']].forEach(function (f) {
        var d = el('div');
        var id = 'p' + i + '-' + f[0];
        d.appendChild(el('label', { for: id }, f[1]));
        var inp = el('input', { id: id, type: f[0] === 'mobile' ? 'tel' : 'text', autocomplete: f[2], placeholder: f[0] === 'called' ? 'For example: Grandma' : '' });
        inp.value = p[f[0]];
        inp.addEventListener('input', function () { p[f[0]] = inp.value; if (f[0] !== 'mobile') head.firstChild.textContent = p.called || p.name || 'Person ' + (i + 1); render(); });
        d.appendChild(inp);
        row.appendChild(d);
      });
      wrap.appendChild(row);
      var pd = el('div');
      var pid = 'p' + i + '-place';
      pd.appendChild(el('label', { for: pid }, p.townOnly ? 'Their town' : site.placeLabel));
      var pin = el('input', { id: pid, type: 'text', autocomplete: 'off' });
      pin.value = p.place;
      pin.addEventListener('input', function () { p.place = pin.value; });
      pd.appendChild(pin);
      var sw = el('button', { type: 'button', class: 'textbtn', style: 'margin-top:8px' }, p.townOnly ? 'I know their address' : 'I only know their town');
      sw.addEventListener('click', function () { p.townOnly = !p.townOnly; drawPeople(); });
      pd.appendChild(sw);
      if (p.townOnly) pd.appendChild(el('p', { class: 'hint' }, "We'll route you to the middle of town and leave a line in the book to write their address in."));
      wrap.appendChild(pd);
      box.appendChild(wrap);
    });
    $('fb-add').hidden = state.people.length >= 8;
    $('fb-people-note').textContent = state.people.length >= 8 ? 'Up to 8 people per book.' : '';
  }
  $('fb-add').addEventListener('click', function () {
    state.people.push({ name: '', called: '', mobile: '', place: '', townOnly: false });
    drawPeople();
    var last = $('p' + (state.people.length - 1) + '-name');
    if (last) last.focus();
  });

  function drawEditions() {
    var box = $('fb-editions');
    box.textContent = '';
    cfg.editions.forEach(function (e) {
      var lab = el('label', { class: 'edition' });
      var r = el('input', { type: 'radio', name: 'edition', value: e.key });
      r.checked = e.key === state.edition;
      r.addEventListener('change', function () { state.edition = e.key; render(); });
      lab.appendChild(r);
      var main = el('span', { class: 'e-main' });
      main.appendChild(el('span', { class: 'e-name' }, e.name));
      main.appendChild(el('br'));
      main.appendChild(el('span', { class: 'e-blurb' }, e.blurb));
      lab.appendChild(main);
      lab.appendChild(el('span', { class: 'e-price' }, money(e.price)));
      box.appendChild(lab);
    });
  }

  // Second address: a second book of the same edition for another home, half price through the
  // "Second address half price" automatic discount (Shopify rounds the discount down: $29.99 -> $15.00)
  var half = function (p) { return p - Math.floor(p / 2); };
  var second = function () { return $('f-second').checked; };
  $('f-second').addEventListener('change', function () {
    $('fb-secondbox').hidden = !this.checked;
    $('fb-secondbox').style.display = this.checked ? 'flex' : 'none';
    render();
  });
  $('f-s-address').addEventListener('input', render);
  ['f-s-city', 'f-s-postcode', 'f-s-email'].forEach(function (id) { $(id).addEventListener('input', render); });
  ['f-s-adults', 'f-s-kids', 'f-s-region'].forEach(function (id) { $(id).addEventListener('change', render); });
  var secondHousehold = function () {
    var a = Number($('f-s-adults').value), k = Number($('f-s-kids').value);
    return a + (a === 1 ? ' adult' : ' adults') + (k ? ', ' + k + (k === 1 ? ' child' : ' children') : '');
  };

  $('f-gift').addEventListener('change', function () {
    $('fb-giftbox').hidden = !this.checked;
    $('fb-giftbox').style.display = this.checked ? 'flex' : 'none';
    render();
  });

  function tooMany() {
    if (!noPeople() || !filledPeople().length) return '';
    return edition().name + " has no people pages or routes, so the people you added won't be in it. Choose Family to keep them.";
  }
  var bookPeople = function () { return noPeople() ? [] : filledPeople(); };

  function household() {
    var c = state.counts, out = [];
    out.push(c.adults + (c.adults === 1 ? ' adult' : ' adults'));
    if (c.kids) out.push(c.kids + (c.kids === 1 ? ' child' : ' children'));
    if (c.pets) out.push(c.pets + (c.pets === 1 ? ' pet' : ' pets'));
    return out.join(', ');
  }

  function personLine(p) {
    var bits = [p.called.trim() ? p.called.trim() + ': ' + p.name.trim() : p.name.trim()];
    if (p.mobile.trim()) bits.push(p.mobile.trim());
    bits.push((p.townOnly ? 'town: ' : '') + p.place.trim());
    return bits.join(', ');
  }

  function validate(step) {
    if (step === 0) {
      if ($('f-gift').checked && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('f-giftemail'))) return 'Please add their email so we can send it to them.';
      if ($('f-gift').checked && val('f-giftemail').toLowerCase() !== val('f-giftemail2').toLowerCase()) return "The two email addresses don't match. Please check their email.";
    }
    if (step === 1) {
      if (!val('f-address')) return 'Please add your street address.';
      if (!val('f-city')) return 'Please add your ' + site.cityLabel.toLowerCase() + '.';
      if (!val('f-region')) return 'Please choose your ' + site.regionLabel.toLowerCase() + '.';
      if (!new RegExp(site.postRe, 'i').test(postcode())) return site.postErr;
    }
    if (step === 2) {
      var bad = state.people.filter(function (p) { return (p.name.trim() || p.place.trim()) && (!p.name.trim() || !p.place.trim()); });
      if (bad.length) return 'Each person needs a name and an address or town.';
    }
    if (step === 4 && second()) {
      if (!val('f-s-address')) return 'Please add the street address for the second book.';
      if (!val('f-s-city')) return 'Please add the ' + site.cityLabel.toLowerCase() + ' for the second book.';
      if (!val('f-s-region')) return 'Please choose the ' + site.regionLabel.toLowerCase() + ' for the second book.';
      if (!new RegExp(site.postRe, 'i').test(postcode('f-s-'))) return site.postErr.replace('Please add', 'For the second book, please add');
      if (val('f-s-email') && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('f-s-email'))) return "Their email doesn't look right. Please check it, or leave it blank and we'll send the book to you.";
    }
    if (step === 4 && !$('f-consent').checked) return 'Please tick the box to confirm.';
    return '';
  }

  function review() {
    var dl = $('fb-review');
    dl.textContent = '';
    var add = function (k, v) { if (!v) return; var d = el('div'); d.appendChild(el('dt', null, k)); d.appendChild(el('dd', null, v)); dl.appendChild(d); };
    add('Home', homeLine());
    add('Household', household());
    add('Notes', state.flags.join(', '));
    if (!noPeople()) {
      bookPeople().forEach(function (p, i) { add('Person ' + (i + 1), personLine(p)); });
      add('Meet first at', val('f-meet1') || 'We suggest one near you');
      add('Then at', val('f-meet2'));
      add('Agreed check-in person', val('f-checkin'));
    }
    if (kidCard()) add("Child's card", val('f-kid'));
    add('Book', edition().name + ' (PDF)');
    if ($('f-gift').checked) { add('Gift for', val('f-giftemail')); add('Gift note', val('f-giftnote') || 'No note'); }
    if (second() && val('f-s-address')) add('Second book', edition().name + ' for ' + homeLine('f-s-') + ', ' + secondHousehold() + (val('f-s-email') ? ', sent to ' + val('f-s-email') : ', sent to you'));
  }

  function render() {
    root.querySelectorAll('.step').forEach(function (s) { s.classList.toggle('on', Number(s.getAttribute('data-step')) === state.step); });
    var shown = [];
    root.querySelectorAll('#fb-steps li').forEach(function (li, i) {
      li.hidden = skipped(i);
      li.className = i === state.step ? 'on' : (i < state.step ? 'done' : '');
      if (!li.hidden) shown.push(i);
    });
    $('fb-stepnum').textContent = 'Step ' + (shown.indexOf(state.step) + 1) + ' of ' + shown.length + ': ' + root.querySelectorAll('#fb-steps li')[state.step].textContent;
    $('fb-kidrow').hidden = !(state.counts.kids > 0 && edition().key !== 'area');
    root.querySelectorAll('.counter').forEach(function (c) { c.querySelector('output').textContent = state.counts[c.getAttribute('data-count')]; });
    $('fb-back').style.display = state.step === 0 ? 'none' : '';
    $('fb-next').textContent = state.step === 4 ? 'Go to payment' : 'Next';
    var tm = tooMany();
    $('fb-toomany').hidden = !tm;
    $('fb-toomany').textContent = tm;
    if (state.step === 4) review();

    var e = edition(), lines = $('fb-sum-lines');
    lines.textContent = '';
    var line = function (a, b) { var d = el('div', { class: 'line' }); d.appendChild(el('span', null, a)); d.appendChild(el('span', null, b)); lines.appendChild(d); };
    line(e.name + ' (PDF)', money(e.price));
    var total = e.price;
    if (second()) { line(e.name + ' for ' + (val('f-s-address') || 'another address') + ' (half price)', money(half(e.price))); total += half(e.price); }
    $('fb-second-price').textContent = '+' + money(half(e.price));
    $('fb-sum-total').textContent = money(total) + ' ' + site.currency;
    var home = val('f-address');
    $('fb-sum-title').textContent = home ? 'Your book for ' + home : 'Your book';
    var eta = 'PDF by email within a day, to print at home.';
    if ($('f-gift').checked) eta += ' Sent to them by email, with your note.';
    $('fb-sum-eta').textContent = eta;
  }

  function showError(msg) {
    var err = $('fb-error');
    if (state.step !== 4) {
      err = root.querySelector('.step.on .err') || (function () { var p = el('p', { class: 'err' }); root.querySelector('.step.on').appendChild(p); return p; })();
    }
    err.hidden = !msg;
    err.textContent = msg;
  }

  // Put the visitor's cart in this country's market (its currency and prices) before the book goes in,
  // so the checkout matches the page. If the market isn't set up yet, Shopify keeps the shop currency.
  function localize() {
    var f = $('fb-localize');
    if (!f || cfg.cartCurrency === site.currency) return Promise.resolve();
    var fd = new FormData(f);
    fd.set('country_code', site.country);
    fd.set('return_to', '/cart.js');
    return fetch(f.getAttribute('action') || '/localization', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
  }

  function checkout() {
    var props = {
      'Home': homeLine(),
      'Country': site.name,
      'Household': household()
    };
    if (state.flags.length) props['Notes'] = state.flags.join(', ');
    bookPeople().forEach(function (p, i) { props['Person ' + (i + 1)] = personLine(p); });
    if (!noPeople()) {
      if (val('f-meet1')) props['Meet first at'] = val('f-meet1');
      if (val('f-meet2')) props['Then at'] = val('f-meet2');
      if (val('f-checkin')) props['Agreed check-in person'] = val('f-checkin');
    }
    if (kidCard()) props["Child's card"] = val('f-kid');
    if ($('f-gift').checked) { props['Gift for'] = val('f-giftemail'); props['Gift note'] = val('f-giftnote') || '(no note)'; }
    // Hidden copy for the book builder (underscore properties don't show at checkout). Shape fixed in INTERNATIONAL-PLAN.md.
    props['_book'] = JSON.stringify({
      v: 1, country: site.country, edition: state.edition,
      address: val('f-address'), city: val('f-city'), region: val('f-region'), postcode: postcode(),
      adults: state.counts.adults, kids: state.counts.kids, pets: state.counts.pets, flags: state.flags,
      people: bookPeople().map(function (p) { return { name: p.name.trim(), called: p.called.trim(), mobile: p.mobile.trim(), place: p.place.trim(), townOnly: p.townOnly }; }),
      meet1: noPeople() ? '' : val('f-meet1'), meet2: noPeople() ? '' : val('f-meet2'), checkin: noPeople() ? '' : val('f-checkin'), kid: kidCard(),
      gift: $('f-gift').checked ? { email: val('f-giftemail'), note: val('f-giftnote') } : null,
      print: 0
    });

    var items = [{ id: edition().id, quantity: 1, properties: props }];
    if (second()) {
      // its own line, so the book builder makes it as a separate book (order #1234-2)
      var sp = { 'Home': homeLine('f-s-'), 'Country': site.name, 'Household': secondHousehold(), 'Second address': 'Yes' };
      if (val('f-s-email')) { sp['Gift for'] = val('f-s-email'); sp['Gift note'] = '(no note)'; }
      sp['_book'] = JSON.stringify({
        v: 1, country: site.country, edition: state.edition,
        address: val('f-s-address'), city: val('f-s-city'), region: val('f-s-region'), postcode: postcode('f-s-'),
        adults: Number($('f-s-adults').value), kids: Number($('f-s-kids').value), pets: 0, flags: [], people: [],
        meet1: '', meet2: '', checkin: '', kid: '', gift: val('f-s-email') ? { email: val('f-s-email'), note: '' } : null, print: 0
      });
      items.push({ id: edition().id, quantity: 1, properties: sp });
    }
    var btn = $('fb-next');
    btn.disabled = true;
    btn.textContent = 'One moment';
    localize()
      .then(function () { return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }); })
      .then(function () {
        var h = 'none';
        try { h = localStorage.getItem('fb_headline') || 'none'; } catch (e) {}
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { Headline: h, 'Country page': site.page } }) });
      })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/checkout'; })
      .catch(function () {
        btn.disabled = false;
        render();
        showError('Something went wrong adding your book. Please try again, or email us.');
      });
  }

  $('fb-next').addEventListener('click', function () {
    var msg = validate(state.step);
    showError(msg);
    if (msg) return;
    if (state.step === 4) { checkout(); return; }
    state.step += 1;
    while (skipped(state.step)) state.step += 1;
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  $('fb-back').addEventListener('click', function () {
    showError('');
    state.step = Math.max(0, state.step - 1);
    while (skipped(state.step)) state.step -= 1;
    render();
  });
  $('f-address').addEventListener('input', render);

  drawPeople();
  drawEditions();
  render();
})();
